export class SignalRConfigBuilder {
    defaultConfig: ISignalRConfig = {
        accountToken: 'None',
        isAuthenticated: false
    };
    config: ISignalRConfig;

    constructor() {
        this.config = this.defaultConfig;
    }

    build(): ISignalRConfig {
        return this.config;
    }

    withToken(token: string): SignalRConfigBuilder {
        this.config.accountToken = token;
        return this;
    }

    withAuth(auth: boolean): SignalRConfigBuilder {
        this.config.isAuthenticated = auth;
        return this;
    }
}

window.SignalRConfigBuilder = SignalRConfigBuilder;